<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Contact Us"
                   :links="[{title:'Home', url:'/'},{title:'Contact Us'}]"></page-header>
      <div class="container-2">
        <section class="content">
          <div class="flex flex-col sm:flex-row">
            <div class="bg-pink-600 flex-1 flex flex-col justify-center gap-y-4 p-4">
              <div class="flex items-center">
                <div
                    class="py-4 px-5 w-16 max-w-min rounded-full bg-gray-200 text-center border-gray-200 shadow-lg mr-3">
                  <i class="pi pi-map-marker text-pink-600 text-2xl font-bold animate-pulse"></i>
                </div>
                <p class="text-white font-medium">S.N.D. College of Engineering and Research Center,
                  Tal. Yeola, Dist. Nashik (Maharashtra, India) Pin Code: 423401</p>
              </div>
              <div class="flex items-center justify-start">
                <div
                    class="py-4 px-5 w-16 max-w-min rounded-full bg-gray-200 text-center border-gray-200 shadow-lg mr-3">
                  <i class="pi pi-phone text-pink-600 text-2xl font-bold animate-ping"></i>
                </div>
                <p class="text-white font-medium">+91 02559-225011</p>
              </div>
              <div class="flex items-center justify-start">
                <div
                    class="py-4 px-5 w-16 max-w-min rounded-full bg-gray-200 text-center border-gray-200 shadow-lg mr-3">
                  <i class="pi pi-envelope text-pink-600 text-2xl font-bold animate-bounce"></i>
                </div>
                <p class="text-white font-medium">sndcoe.principal@gmail.com</p>

              </div>
              <img class="object-cover" src="/static/images/routemap-768x341.jpg" alt="">
            </div>
            <div class="flex-1 bg-gray-50 p-4">
              <form class="">
                <div class="flex flex-wrap -mx-3 mb-6">
                  <div class="w-full px-3">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                           for="grid-name">
                      Name
                    </label>
                    <input
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-name" type="text" placeholder="Your Name">
                    <p class="text-red-500 text-xs italic">Please fill out this field.</p>
                  </div>
                </div>
                <div class="flex flex-wrap -mx-3 mb-6">
                  <div class="w-full px-3">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                           for="grid-mobile">
                      Mobile
                    </label>
                    <input
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                        id="grid-mobile" type="phone" placeholder="Mobile">
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3 mb-6">
                  <div class="w-full px-3">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                           for="grid-email">
                      Email Address
                    </label>
                    <input
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                        id="grid-email" type="email" placeholder="********@*****.**">
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3 mb-6">
                  <div class="w-full px-3">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Your Message
                    </label>
                    <textarea rows="10"
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                      </textarea>
                  </div>
                  <div class="flex justify-end w-full px-3">
                    <button
                        class="shadow bg-indigo-600 hover:bg-indigo-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-6 rounded"
                        type="submit">
                      Send Message
                    </button>
                  </div>

                </div>

              </form>

            </div>
          </div>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "landing-page",
  components: {
    KeyRecruiters,
    NavbarComponent,
    PageHeader,
    FooterComponent,
  },

  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped />
